export default {
    when: 'home, page-front',

    mounted(args) {
        console.log('[templateHome] -> mounted on home or page front', args);
    },
};
